<template>
    <div class="tradingview-widget-container">
        <div class="tradingview-widget-container__widget"></div>
    </div>
</template>

<script>
export default {
    name:'TradingViewMini',
    props:['darkTheme','ticker'],
    watch:{
        darkTheme:function(){
            this.createChart();
        },
        ticker:function(){
            this.createChart();
        }
    },
    methods:{
        createChart(){
            if (this.ticker){
                document.querySelector('.tradingview-widget-container').innerHTML = '<div class="tradingview-widget-container__widget"></div>';
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js');
                let theme = this.darkTheme ? "dark" : 'light';
                let underLineColor =  this.darkTheme ? "rgba(55, 166, 239, 0.15)" : "#E3F2FD";
                externalScript.textContent = `{
                "symbol": "${this.ticker}",
                "width": 310,
                "height": 170,
                "locale": "en",
                "dateRange": "12m",
                "colorTheme": "${theme}",
                "trendLineColor": "#37a6ef",
                "underLineColor": "${underLineColor}",
                "isTransparent": false,
                "autosize": false,
                "largeChartUrl": ""
                }`;
                document.querySelector('.tradingview-widget-container').appendChild(externalScript);
            }
        }
    },
    mounted(){
        this.createChart();
    }
}
</script>

<style>

</style>